import type { NextPage } from 'next'
import Head from 'next/head'
import { Ajuda } from 'src/views'

const AjudaPage: NextPage = () => {
  return (
    <>
      <Head>
        <meta charSet="UTF-8" />

        <title>Ajuda - Crédito One</title>

        <meta
          property="og:description"
          content="Tire suas dúvidas sobre como funciona o Crédito One. Veja como é simples e rápido. Estamos aqui para te ajudar."
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="pt_BR" />
        <meta property="og:site_name" content="Crédito One" />
        <meta property="og:title" content="Ajuda - Crédito One" />
        <meta
          name="description"
          content="Tire suas dúvidas sobre como funciona o Crédito One. Veja como é simples e rápido. Estamos aqui para te ajudar."
        />
        <meta
          property="og:image"
          content="https://uploads-ssl.webflow.com/5fb18514177e609c5101c5b2/61aa78267b898128a13bbb31_open%20graph.png"
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Ajuda />
    </>
  )
}

export default AjudaPage
